import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { AppProvisionStatus } from './types/AppProvisioning';
export const requestAppProvisioning = appProvisioningRequest => fetchOk("/gateway/api/marketplace/internal/demand/app-provision", {
  method: 'POST',
  body: JSON.stringify(appProvisioningRequest),
  headers: {
    'Content-Type': 'application/json'
  }
}).then(response => response.json()).then(response => response.provisioningRequestId);
export const calculateRetries = (maximumDurationInMinutes, pollAfter) => maximumDurationInMinutes * 60 * 1000 / pollAfter;
export async function pollCloudAppProvisioningStatus(provisioningRequestId) {
  const pollAfter = 5000;
  const options = {
    retries: calculateRetries(4, pollAfter),
    retryDelay: pollAfter,
    accept: response => response.json().then(bodyJSON => {
      var _bodyJSON$payload$dat;
      const appProvisioningStatus = (_bodyJSON$payload$dat = bodyJSON.payload.data.resourcePackages) === null || _bodyJSON$payload$dat === void 0 ? void 0 : _bodyJSON$payload$dat[0].action.status;
      return appProvisioningStatus === AppProvisionStatus.IN_PROGRESS ? Promise.reject(new Error('Request pending')) : Promise.resolve();
    })
  };
  const response = await fetchOk("/gateway/api/marketplace/internal/demand/app-provision/status/".concat(provisioningRequestId), options);
  const responseJSON = await response.json();
  const appProvisioningStatus = responseJSON.payload.data.resourcePackages[0].action.status;
  if (appProvisioningStatus === AppProvisionStatus.SUCCESS) {
    return Promise.resolve(AppProvisionStatus.SUCCESS);
  } else {
    throw new Error("Polling for app provision status failed for provisioningRequestId: ".concat(provisioningRequestId));
  }
}